const emit = (eventName, detail) =>
  window.dispatchEvent(new CustomEvent(eventName, { detail }));

const on = (eventName, handler, options) =>
  window.addEventListener(eventName, handler, options);

const off = (eventName, handler, options) =>
  window.removeEventListener(eventName, handler, options);

export { emit, on, off };
